"use client";

import {
  createContext,
  type ReactNode,
  useContext,
  useState,
  useEffect,
} from "react";

interface EnvVariablesClientConfig {
  ACKO_ENV: string | undefined;
  DD_RUM_APPLICATION_ID?: string | undefined;
  DD_RUM_CLIENT_TOKEN?: string | undefined;
  DD_RUM_ENV?: string | undefined;
}

const defaultEnvVariables: EnvVariablesClientConfig = {
  ACKO_ENV: "",
  DD_RUM_APPLICATION_ID: undefined,
  DD_RUM_CLIENT_TOKEN: undefined,
  DD_RUM_ENV: undefined,
};

const getRuntimeEnv = () => {
  const script = document.getElementById("env-config") as HTMLScriptElement | null;
  if (!script?.textContent) return undefined;
  return JSON.parse(script.textContent);
};

const EnvVariablesClientContext =
  createContext<EnvVariablesClientConfig>(defaultEnvVariables);

interface EnvClientProviderProps {
  children: ReactNode;
}

export const EnvVariablesClientProvider: React.FC<EnvClientProviderProps> = ({
  children,
}) => {
  const [envs, setEnvs] =
    useState<EnvVariablesClientConfig>(defaultEnvVariables);

  useEffect(() => {
    const runtimeEnvs = getRuntimeEnv();
    setEnvs(runtimeEnvs);
  }, []);

  return (
    <EnvVariablesClientContext.Provider value={envs}>
      {children}
    </EnvVariablesClientContext.Provider>
  );
};

export const useEnvVariablesClientConfig = (): EnvVariablesClientConfig => {
  if (EnvVariablesClientContext === undefined) {
    throw new Error(
      "useEnvVariablesClientConfig must be used within an EnvVariablesClientProvider"
    );
  }

  return useContext(EnvVariablesClientContext);
};
